import { render, staticRenderFns } from "./errorDetail.vue?vue&type=template&id=05c85186&scoped=true"
import script from "./errorDetail.vue?vue&type=script&lang=js"
export * from "./errorDetail.vue?vue&type=script&lang=js"
import style0 from "./errorDetail.vue?vue&type=style&index=0&id=05c85186&prod&ref=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c85186",
  null
  
)

export default component.exports